module.exports = __webpack_public_path__ + "static/1-1d213a8ad5bb7033d6a955dc5793a1ae.jpg";